"use client"

import { useState } from "react"
import "./MFFaq.css"

const faqData = [
  {
    question: "What is Manufacturing software development?",
    answer:
      "Manufacturing software development involves creating customised solutions to streamline and optimise manufacturing processes. These solutions can range from production planning and inventory management to quality control and supply chain management, aiming to increase efficiency, reduce costs, and enhance production quality.",
  },
  {
    question: "How does Manufacturing software imporoves product efficiency?",
    answer:
      "Manufacturing software enhances production efficiency by automating routine tasks, reducing manual errors, and providing real-time visibility into production processes. It enables better resource allocation, minimises downtime, and facilitates quicker decision-making based on accurate data, leading to smoother operations and increased output.",
  },
  {
    question: "Can Manufacturing software be integrated with existing systems?",
    answer:
      "Yes, most modern manufacturing software solutions are designed to be highly integrated with existing systems such as ERP (Enterprise Resource Planning), CRM (Customer Relationship Management), and SCM (Supply Chain Management) software. This ensures a seamless flow of information across different departments and functions, enhancing overall operational efficiency.",
  },
  {
    question:
      "How does manufacturing software support supply chsin management?",
    answer:
      "Manufacturing software supports supply chain management by providing tools for better demand forecasting, inventory optimisation, supplier management, and logistics planning. It enables manufacturers to maintain optimal inventory levels, reduce lead times, and improve supplier collaboration, ensuring timely delivery of products.",
  },
  {
    question: "What are the challenges in manufacturing software development?",
    answer:
      "Challenges include ensuring the software is scalable and flexible enough to adapt to changing manufacturing processes, integrating with diverse existing systems, meeting industry-specific compliance and security standards, and providing user-friendly interfaces that require minimal training.",
  },
  {
    question: "How should i choose the right manufacturing software development partner?",
    answer:
      "Choosing the right development partner involves evaluating their experience in the manufacturing sector, understanding their development capabilities, assessing their approach to project management and communication, and reviewing their portfolio of similar projects. It's also important to consider their post-development support and maintenance services.",
  },
  {
    question:
      "How long odes it take to develop custom manufacturing software?",
    answer:
      "The development time for custom manufacturing software can vary widely depending on the complexity of the requirements, the level of customisation needed, and the integration with existing systems. Projects can range from a few months to over a year. A detailed project scope and timeline should be established early in development.",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section4761">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">MANUFACTURING SOFTWARE DEVELOPMENT</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default FAQSection
